export default {
  items: {},
  navTreeRootId: null,
  navTree: [],
  selectedTreeItemId: null
}
